import { useSearchParams } from 'react-router-dom';
import type { DayState } from '@daily/shared';
import clsx from 'clsx';

const STATES: (DayState | 'auto')[] = ['auto', 'morning', 'afternoon', 'evening', 'night'];

interface DayStatePreviewProps {
  active: DayState;
}

export function DayStatePreview({ active }: DayStatePreviewProps) {
  const [params, setParams] = useSearchParams();
  const override = params.get('state');
  const current = override ?? 'auto';

  const set = (s: (typeof STATES)[number]) => {
    const next = new URLSearchParams(params);
    if (s === 'auto') next.delete('state');
    else next.set('state', s);
    setParams(next, { replace: true });
  };

  return (
    <div className="fixed bottom-5 left-5 z-40 hidden md:flex items-center gap-1 px-2 py-1.5 rounded-full bg-card/90 backdrop-blur shadow-sm border border-black/5 text-[10px] tracking-[0.16em] uppercase">
      <span className="text-inkFaded pr-1">preview</span>
      {STATES.map((s) => (
        <button
          key={s}
          type="button"
          onClick={() => set(s)}
          className={clsx(
            'px-2 py-1 rounded-full font-medium',
            (s === current || (s === 'auto' && !override))
              ? 'bg-tomato text-white'
              : 'text-inkSoft hover:bg-cardWarm',
          )}
        >
          {s}
        </button>
      ))}
      <span className="pl-1 text-inkFaded">· now: {active}</span>
    </div>
  );
}
